export * from './Font';

export function useFonts() {
  return [];
}
